import { QueryClient, useQuery } from 'react-query';
import { QueryKeys } from './QueryKeys';
import { apiFetch, ApiFetch, useApiClient } from './useApiClient';

type Params = {
  readonly username?: string;
};

export type ProfileByUsernameQueryResult = {
  readonly profile: {
    readonly profile_id?: string;
    readonly profile_name?: string;
    readonly username?: string | null;
    readonly website_url?: string | null;
    readonly instagram_account?: string | null;
    readonly image_url?: string | null;
  };
};

export function useProfileByUsernameQuery({ username }: Params) {
  const api = useApiClient();

  return useQuery(QueryKeys.profileByUsername(username, {}), () => fetchProfileByUsername(api.fetch, { username }), {
    enabled: !!username,
  });
}

export async function prefetchProfileByUsernameQuery(client: QueryClient, { username }: Params) {
  return await client.prefetchQuery(QueryKeys.profileByUsername(username, {}), () =>
    fetchProfileByUsername(apiFetch, { username }),
  );
}

async function fetchProfileByUsername(fetch: ApiFetch, { username }: Params) {
  const res = await fetch(`/web/profiles/${username}`);
  return res.json();
}
